import { type Ref } from 'react';

import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerProps,
  Typography,
} from '@cast/design-system';
import { OptimizationWorkloadPod } from '@cast/types';
import { PreparedWorkload } from '@cast/split-me/features/workload-optimization';

import { PodListTable } from './PodListTable';

export type PodListDrawerBaseProps = {
  pods: OptimizationWorkloadPod[];
  // `PreparedWorkload` matches `WorkloadDetailsContext.workload` and is
  // accepted by `isWorkloadOptimizationDisabled` via its union parameter type.
  workload?: PreparedWorkload;
};

type Props = DrawerProps &
  PodListDrawerBaseProps & {
    ref?: Ref<HTMLDivElement>;
  };

export const PodListDrawer = ({
  ref,
  pods,
  workload,
  ...drawerProps
}: Props) => {
  return (
    <Drawer ref={ref} size="large" testId="pod-list-drawer" {...drawerProps}>
      <DrawerHeader />
      <DrawerBody height="100%">
        <DrawerContent>
          <Typography variant="h5" mb={16}>
            Pod list
          </Typography>
          <PodListTable pods={pods} workload={workload} />
        </DrawerContent>
      </DrawerBody>
    </Drawer>
  );
};
